import React from 'react';
import PropTypes from 'prop-types';
import GigCollect from '@fiverr-private/gig_collect/src/GigCollect';
import { FIT_MODAL_CLASS } from '../../../utils/constants';

import './style.scss';

const AddToFavorite = ({ collections, currentUser, gigCollectedCount, gigId, sellerId, updateCollections }) => (

    <div className="gig-fav-wrapper">
        <GigCollect gigId={gigId}
            sellerId={sellerId}
            currentUser={currentUser}
            iconHeartHintPos="hint--bottom-right"
            iconListHintPos="hint--bottom-right"
            showCollMenu={true}
            showHeartText={true}
            collections={collections}
            updateCollections={updateCollections}
            trackingPrefix="gig_page"
            colMenuOpenDirection="bottom"
            modalCustomName={FIT_MODAL_CLASS}/>
        <span className="collect-count">{gigCollectedCount}</span>
    </div>

);

AddToFavorite.propTypes = {
    collections: PropTypes.object,
    currentUser: PropTypes.object,
    gigId: PropTypes.number.isRequired,
    gigCollectedCount: PropTypes.number,
    sellerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    updateCollections: PropTypes.func
};

export default AddToFavorite;

